import type EntityParameterSettings from "@/interfaces/Parameters/EntityParameterSettings";
import type ParameterSettings from "@/interfaces/Parameters/ParameterSettings";
import { portalHttpClient } from "@/services/httpClient";

const END_POINT = "api/customerPortal/v1/parameterSettings";

export async function getParameterSettings(): Promise<ParameterSettings> {
  const response = await portalHttpClient.get(END_POINT);
  return response.data as ParameterSettings;
}

export async function getEntityParameterSettings(): Promise<EntityParameterSettings> {
  const response = await portalHttpClient.get(`${END_POINT}/entity`);
  return response.data as EntityParameterSettings;
}
